/**
 * Turns a string into a slug
 * @see https://gist.github.com/codeguy/6684588#gistcomment-3332719
 * @param {string} str
 * @returns {string}
 */
export const slugify = (str) => {
    return str
        .toString()
        .normalize( 'NFD' )                   // split an accented letter in the base letter and the acent
        .replace( /[\u0300-\u036f]/g, '' )   // remove all previously split accents
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/\.+/g, '-') // Replace periods with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-'); // Replace multiple - with single -
}

export default {
    slug: slugify
}